import { Skeleton } from "@/components/ui/skeleton";
import CommunityRowSkeleton from "@/components/community/CommunityRowSkeleton";

// Same blocks as SavedCommunitiesPage: title and subtitle, the underline tabs, three stat tiles, the sort bar and the list.
// It stands in for the page while its code loads and while access is checked, so the screen shows one shape
// from the first frame to the last. Keep it in step with the page.
const SavedSkeleton = () => (
  <div className="ernest-container space-y-6 py-8 pb-[13px] pt-[40px]" aria-busy="true" aria-label="Loading">
    <div>
      <Skeleton className="mb-1 h-8 w-40" />
      <Skeleton className="mb-[10px] h-6 w-72 max-w-full" />
    </div>
    <div>
      <div className="flex items-center gap-[34px] border-b border-border/70 pb-2.5">
        <Skeleton className="h-5 w-28" />
        <Skeleton className="h-5 w-28" />
      </div>
      <div className="mt-6 space-y-6">
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
          {[0, 1, 2].map((i) => <Skeleton key={i} className="h-[86px] rounded-2xl" />)}
        </div>
        <div className="flex items-center gap-2">
          <Skeleton className="h-4 w-12" />
          <Skeleton className="h-[30px] w-20 rounded-full" />
          <Skeleton className="h-[30px] w-16 rounded-full" />
        </div>
        <div className="flex flex-col gap-1.5">
          {[0, 1, 2].map((i) => <CommunityRowSkeleton key={i} />)}
        </div>
      </div>
    </div>
  </div>
);

export default SavedSkeleton;
